__turbopack_context__.v({
  "LiveTVEmbed": "LiveTVEmbed-module-scss-module__x5DemG__LiveTVEmbed",
  "title": "LiveTVEmbed-module-scss-module__x5DemG__title",
});
